module.exports = __webpack_public_path__ + "img/apache2.d3b0cb8a.png";